import { AwsCaseStudy } from "../../src/landingPage/views/AwsCaseStudy/AwsCaseStudy";
import butter from "../../src/landingPage/utils/butter-client";
import { linksConstants } from "../../src/constants/linksConstants";
import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";

const AwsCaseStudyPage = ({ title, content, resolvedUrl }) => {
  return (
    <>
      <NextHead
        currentPath={resolvedUrl}
        title={title}
        pageImageUrl={content?.featured_image ? content?.featured_image : null}
      />
      <AwsCaseStudy {...{ title, content }} />
    </>
  );
};

export default AwsCaseStudyPage;

export const getServerSideProps = async ctx => {
  try {
    const { id } = ctx.params;
    const { resolvedUrl } = ctx;
    const response = await butter.page.retrieve("aws-case-study", id, {});
    const { data: post } = response.data;
    const { name: title, fields: content } = post;
    return {
      props: {
        resolvedUrl,
        title,
        content,
        wrapper: "MarketingWrapper",
      },
    };
  } catch (e) {
    return {
      redirect: {
        destination: linksConstants.HOME,
        permanent: false,
      },
    };
  }
};
